import DestinationGroup from '../components/templates/[destination-group-id]';

export const DestinationGroupContainer = () => {
  return <DestinationGroup />;
};
